import React from 'react';
import HeroSection from '../components/HeroSection';
import ServicePlan from '../components/ServicePlan';
const Home = () => {
  const servicePlans = [{
    title: 'One-Year Service Plan – 1 Appliance',
    price: '£99.00',
    description: 'Reliable cover for your appliance with 12 months of unlimited repairs, priority support, and expert engineer care.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3DabzyMNDtjFRNbS6t5UZm/20._Washing_Machine.png',
    imageAlt: 'Technician repairing washing machine',
    buttonLink: 'https://buy.stripe.com/00w3coc3Pd318LG14Jdwc01'
  }, {
    title: 'One-Year Service Plan – TV + Set-Top Box',
    price: '£120.00',
    description: 'Protect your home entertainment with unlimited repairs and rapid-response service for your TV and set-top box.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8p76EKMTFRWVwTZi5Me1qw/6.png',
    imageAlt: 'Family watching sports on TV',
    buttonLink: 'https://buy.stripe.com/3cI4gs5Frfb94vq8xbdwc00'
  }];
  return <div data-id="element-284">
      <HeroSection data-id="element-285" />
      {/* Introduction Section */}
      <section className="py-16 bg-gray-50" data-id="element-286">
        <div className="container mx-auto px-4" data-id="element-287">
          <div className="max-w-3xl mx-auto text-center" data-id="element-288">
            <h2 className="text-3xl font-bold text-[#1a3a6c] mb-6" data-id="element-289">
              Welcome to Opticore
            </h2>
            <p className="text-lg text-gray-700 mb-8" data-id="element-290">
              We specialise in fast, professional appliance repairs and service
              plans across the UK. Our team of expert engineers is dedicated to
              providing reliable, high-quality repairs with transparent pricing
              and exceptional customer service. With our fixed-price service
              plans, you can enjoy complete peace of mind knowing your essential
              home appliances are protected.
            </p>
            <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-[#f97316]" data-id="element-291">
              <p className="italic text-gray-600" data-id="element-292">
                "Excellent service from start to finish. The engineer was
                professional, knowledgeable, and fixed our washing machine
                quickly. Highly recommend Opticore for appliance repairs!"
              </p>
              <p className="mt-4 font-medium text-[#1a3a6c]" data-id="element-293">
                Sarah Thompson, Birmingham
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Service Plans Section */}
      <section className="py-16 bg-white" data-id="element-294">
        <div className="container mx-auto px-4" data-id="element-295">
          <h2 className="text-3xl font-bold text-center text-[#1a3a6c] mb-12" data-id="element-296">
            Our Service Plans
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-297">
            {servicePlans.map((plan, index) => <ServicePlan key={index} title={plan.title} price={plan.price} description={plan.description} imageUrl={plan.imageUrl} imageAlt={plan.imageAlt} buttonLink={plan.buttonLink} data-id="element-298" />)}
          </div>
        </div>
      </section>
      {/* Call to Action Section */}
      <section className="py-16 bg-[#3b82f6] text-white" data-id="element-299">
        <div className="container mx-auto px-4 text-center" data-id="element-300">
          <h2 className="text-3xl font-bold mb-6" data-id="element-301">
            Need Help With Your Appliances?
          </h2>
          <p className="text-lg mb-8 max-w-2xl mx-auto" data-id="element-302">
            Our expert engineers are ready to help you with any appliance repair
            or maintenance needs. Contact us today for fast, reliable service.
          </p>
          <a href="tel:08000554969" className="inline-block bg-white text-[#1a3a6c] font-bold py-3 px-8 rounded-md hover:bg-gray-100 transition-colors" data-id="element-303">
            Call 0800 055 4969
          </a>
        </div>
      </section>
    </div>;
};
export default Home;